
const ProductUpdates = () => (
  <div className="pt-24 px-6 max-w-7xl mx-auto">
    <h1 className="text-4xl font-bold mb-8">Product Updates</h1>
    <p>Stay updated with the latest Assembly platform features and improvements.</p>
  </div>
);

export { Page }

function Page() {
  return <ProductUpdates />;
}
